import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function createDeeplinkUrlConfiguration() {
  return new NetworkRequestConfiguration({
    endpoint: 'deeplink_url/app_link_for_authenticated_user',
    method: NetworkRequestConfiguration.Methods.POST,
    successCodes: [201],
  });
}
